import { Component, OnInit, OnDestroy, Renderer2, Inject } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs';
@Component({
  selector: 'app-blog-business-process-automation',
  imports: [CommonModule, RouterModule],
  standalone: true,
  templateUrl: './blog-business-process-automation.component.html',
  styleUrl: './blog-business-process-automation.component.scss'
})
export class BlogBusinessProcessAutomationComponent implements OnInit, OnDestroy {

  constructor(private router: Router, private activatedRoute: ActivatedRoute,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private _document: Document
  ) { }
  private jsonLdScript: any;
  ngOnInit(): void {
    this.injectSchemaMarkup();
    this.router.events.pipe(
      filter((event: any) => event instanceof NavigationEnd),
      map(() => this.activatedRoute),
      map((route) => {
        while (route.firstChild) route = route.firstChild;
        return route;
      }),
      filter((route) => route.outlet === 'primary'),
      mergeMap((route: { data: any; }) => route.data)
    )
      .subscribe((event: any) => {
        if (this.router.url === '/blogs/business-process-automation') {
          this.updateDescription(event.description, event.keywords, event.title);
        }
      });
  }
  ngOnDestroy(): void {
    this.removeSchemaMarkup();
  }
  injectSchemaMarkup(): void {
    const bpaSchema = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id": "https://www.kalpitatechnologies.com/tech-blogs/business-process-automation#webpage",
          "url": "https://www.kalpitatechnologies.com/tech-blogs/business-process-automation",
          "name": "10 Key Benefits of Business Process Automation with Custom Software | Kalpita Technologies",
          "description": "Comprehensive guide to the 10 key benefits of business process automation using custom software, covering time savings, reliability, productivity, and scalability.",
          "isPartOf": {
            "@type": "WebSite",
            "@id": "https://www.kalpitatechnologies.com/#website",
            "name": "Kalpita Technologies",
            "url": "https://www.kalpitatechnologies.com"
          },
          "inLanguage": "en"
        },
        {
          "@type": "BreadcrumbList",
          "@id": "https://www.kalpitatechnologies.com/tech-blogs/business-process-automation#breadcrumb",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "item": { "@type": "WebPage", "@id": "https://www.kalpitatechnologies.com/", "name": "Home" } },
            { "@type": "ListItem", "position": 2, "item": { "@type": "WebPage", "@id": "https://www.kalpitatechnologies.com/tech-blogs/blog", "name": "Blog Index" } },
            { "@type": "ListItem", "position": 3, "item": { "@type": "WebPage", "@id": "https://www.kalpitatechnologies.com/tech-blogs/business-process-automation", "name": "BPA Benefits" } }
          ]
        },
        {
          "@type": "BlogPosting",
          "@id": "https://www.kalpitatechnologies.com/tech-blogs/business-process-automation#blogposting",
          "headline": "10 Key Benefits of Business Process Automation with Custom Software",
          "articleBody": "Business process automation is the use of technology such as software and tools to automate repetitive business tasks and multistep business transactions...",
          "author": { "@type": "Person", "name": "Nagaraj R K" },
          "publisher": {
            "@type": "Organization",
            "name": "Kalpita Technologies",
            "@id": "https://www.kalpitatechnologies.com/#organization"
          },
          "datePublished": "2022-12-26",
          "image": { "@type": "ImageObject", "url": "https://www.kalpitatechnologies.com/assets/resources/blog/business-process/business-processmain.png" }
        },
        {
          "@type": "FAQPage",
          "@id": "https://www.kalpitatechnologies.com/tech-blogs/business-process-automation#faqpage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "What is business process automation?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Business process automation (BPA) is the use of technology such as software and tools to automate repetitive business tasks and multistep business transactions."
              }
            }
          ]
        },
        {
          "@type": "Organization",
          "@id": "https://www.kalpitatechnologies.com/#organization",
          "name": "Kalpita Technologies",
          "url": "https://www.kalpitatechnologies.com",
          "logo": { "@type": "ImageObject", "url": "https://www.kalpitatechnologies.com/assets/resources/kalpita-logo.png" }
        }
      ]
    };

    this.jsonLdScript = this.renderer.createElement('script');
    this.jsonLdScript.type = 'application/ld+json';
    this.jsonLdScript.text = JSON.stringify(bpaSchema);
    this.renderer.appendChild(this._document.head, this.jsonLdScript);
  }

  removeSchemaMarkup(): void {
    if (this.jsonLdScript) {
      this.renderer.removeChild(this._document.head, this.jsonLdScript);
      this.jsonLdScript = null;
    }
  }
  updateDescription(desc: string, keywords: string, title: string) {
    // this.seoService.updateDescription(desc);
    // this.seoService.updateMetaKeywords(keywords);
    // this.seoService.updateTitle(title);
  }
  scroll(target: HTMLElement) {
    target.scrollIntoView({ behavior: 'smooth' });
  }
}
